import * as nice from "./nice";

export const plugins = {
    ...nice,
};
